export enum EFiltersPainelIntegracoesTable {
  INTEGRACAO = "integracao",
  STATUS = "status",
  TYPE = "tipo"
}

//status sucesso/erro/pendente
export type PainelIntegracoesTableData = {
  id: string;
  integracao: string;
  status: string;
  empresa: string;
};
